import React, { createContext, useState } from "react";

import axios from "axios";
import { toastr } from "react-redux-toastr";

import URL from "../../../config/api";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  const user = useState([]);
  const room = useState([]);
  const school = useState([]);

  const correctsByQuestion = useState([]);
  const correctsByAbility = useState([]);
  const correctsByObjective = useState([]);
  const correctsByThematic = useState([]);

  const dataComparisonRegions = useState([]);
  const dataComparisonSchools = useState([]);
  const dataComparisonRooms = useState([]);

  const dataAbility = useState([]);

  const studentHistogram = useState([]);
  const roomHistogram = useState([]);
  const schoolHistogram = useState([]);

  const fetchData = async (params, token, route, setData) => {
    setLoading(true);
    try {
      await axios
        .get(`${URL.api}${route}`, {
          params,
          headers: { authorization: `Bearer ${token}` }
        })
        .then(resp => {
          setData(resp.data.data);
          setFirstLoad(false);
        });
    } catch (error) {
      toastr.error("Error", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DataContext.Provider
      value={{
        correctsByQuestion,
        correctsByAbility,
        correctsByObjective,
        correctsByThematic,
        dataComparisonSchools,
        dataComparisonRegions,
        dataComparisonRooms,
        dataAbility,
        studentHistogram,
        roomHistogram,
        schoolHistogram,
        loading,
        firstLoad,
        user,
        room,
        school,
        fetchData
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
